import * as React from 'react';
import {Link} from "react-router-dom";
import {RouteComponentProps} from "react-router";

export const DashboardsRoute = (props: RouteComponentProps) => {
    const { match } = props;

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Roles & Dashboards
                    </li>
                </ol>
            </nav>

            <div className="list-group admin-list mt-4">
                <Link className="list-group-item list-group-item-action" to={`${match.url}/lp`}>
                    <strong>Language Professional</strong>
                </Link>
                <Link className="list-group-item list-group-item-action" to={`${match.url}/me`}>
                    <strong>Media editor</strong>
                </Link>
                <Link className="list-group-item list-group-item-action" to={`${match.url}/mc`}>
                    <strong>Mnemo creative</strong>
                </Link>
            </div>
        </div>
    </div>
};
